import * as donationAPI from "./data";
import * as appAPI from "./app";

namespace dokodemoFAPI {
  export const data = donationAPI;
  export const app = appAPI;
}

export default dokodemoFAPI;
